export default "__VITE_PUBLIC_ASSET__00615505__"